import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { FileUploadControl, FileUploadModule } from '@iplab/ngx-file-upload';
import { CmsService, ContentSlotData, GlobalMessageService, GlobalMessageType, TranslatePipe } from '@spartacus/core';
import { KnBrCommonService } from '../../../services/kn-br-common.service';
import { KnBrDocViewerComponent } from '../../../common/kn-br-doc-viewer/kn-br-doc-viewer.component';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { KnBrDraftOrdersService } from 'src/app/store/kn-br-draft-orders/kn-br-draft-orders.service';
import { ActiveCartService } from '@spartacus/cart/base/core';

@Component({
    selector: 'kn-br-draft-order-attachment-link',
    templateUrl: './kn-br-draft-order-attachment-link.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [FileUploadModule, NgbTooltip, TranslatePipe]
})
export class KnBrDraftOrderAttachmentLinkComponent implements OnInit {
  @ViewChild('tooltip') tooltip: NgbTooltip;
  modalRef;
  draftOrder: any;
  public fileUploadControl = new FileUploadControl().setListVisibility(false).setValidators([Validators.required]);
  components: ContentSlotData;
  documentTypes =
    '.csv,.DOC,.DOCX, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.pdf';
  constructor(
    private activeCartService: ActiveCartService,
    protected knBrCommonService: KnBrCommonService,
    protected globalMessageService: GlobalMessageService,
    protected cdr: ChangeDetectorRef,
    private cmsService: CmsService,
    private modalService: NgbModal,
    private knBrDraftOrdersService: KnBrDraftOrdersService
  ) {}

  ngOnInit(): void {
    this.activeCartService.getActive().subscribe((response) => {
      this.draftOrder = response as any;
      this.cdr.markForCheck();
      if (this.draftOrder && this.draftOrder.cartAttachment && !this.isDisabled()) {
        this.openToolTip();
      }
    });
    this.knBrDraftOrdersService.loadAttachmentMsg().subscribe((res) => {
      if (res) {
        this.openToolTip();
      } else {
        this.closeToolTip();
      }
    });
    this.fileUploadControl.valueChanges.subscribe((value) => {
      this.closeToolTip();
      if (value && value.length) {
        this.onSubmit();
      }
    });
  }

  openToolTip(): void {
    if (this.tooltip) {
      this.tooltip.open();
    }
  }

  closeToolTip(): void {
    if (this.tooltip) {
      this.tooltip.close();
    }
  }

  openModal() {
    let modalInstance: any;
    this.modalRef = this.modalService.open(KnBrDocViewerComponent, {
      centered: true,
      size: 'lg',
    });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.url = this.draftOrder.docURL;
    modalInstance.attachmentName = this.draftOrder.cartAttachment;
  }

  onSubmit() {
    if (this.draftOrder && !this.draftOrder?.cartAttachment) {
      const formData: FormData = new FormData();
      formData.append('attachment', this.fileUploadControl.value[0]);
      this.knBrCommonService.uploadDraftOrderAttachment(formData);
    } else {
      this.globalMessageService.add({ key: 'knBrMessages.removeFileFirst' }, GlobalMessageType.MSG_TYPE_WARNING);
    }
    this.fileUploadControl.clear();
  }
  removeFile() {
    this.knBrCommonService.deleteDraftOrderAttachment(this.draftOrder.cartAttachment);
  }

  isDisabled() {
    this.cmsService
      .getContentSlot('KnBrDraftOrderHeaderSlot')
      .subscribe((value) => (this.components = value))
      .unsubscribe();

    if (
      (this.components &&
        this.components.components &&
        this.components.components.length &&
        this.components.components[0].flexType === 'KnBrDraftOrderHeaderComponentReadOnly') ||
      !this.draftOrder.editable
    ) {
      return true;
    }
    return false;
  }
}
